module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/10FhF1M/tc-custom/9781614239550.jpg?1702530538531",
      "alt": "This image is the cover for the book RAGBRAI"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("RAGBRAI\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Launched as a lark in 1973, RAGBRAI has developed into the world's largest, longest and oldest bicycle touring event. Thousands of cyclists from all fifty states and dozens of countries ride across Iowa for a weeklong festival. Meanwhile, tens of thousands of hospitable Iowans welcome, feed and shelter this rolling carnival, showcasing their communities. Greg Borzo has gathered hundreds of stories that reveal the essence of this unique event. He has also gathered a lavish collection of photographs and cartoons--vintage and contemporary, most never published before--that illustrate RAGBRAI's kaleidoscopic character.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Greg Borzo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Raised in Des Moines, Greg Borzo is the author of Chicago Cable Cars, Where to Bike Chicago,  and The Chicago \"L.\"? He is a member of the Iowa Bicycle Coalition and the Des Moines Bicycle Collective, as well as the Active Transportation Alliance in Chicago and the Chicago Tour-Guide Professionals Association. John Karras was a bicycle enthusiast and copy editor at the Des Moines Resgister in 1973 when he co-founded RAGBRAI. Over the next four decades, he nurtured the ride, helping it develop into the world's largest, longest and oldest bicycle touring event. Still involved with RAGBRAI, Karras is the person most responsible for its incredible success.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0